import { mutations as types } from "./types";

const mutations = {
  [types.SEARCH_RESULT](state, data) {
    state.articleSearch.searchResult = data;
  },
  [types.TUTORIAL_PLAYLIST_BY_CATEGORY](state, data) {
    state.categorySearch.playList = data;
  },
  [types.CURRENT_LAYOUT](state, data) {
    state.currentLayout = data;
  },
  [types.CALLING_API](state, data) {
    state.isApiCalling = data;
  },
  [types.SHOW_MODAL](state) {
    state.isShowModal = true;
  },
  [types.HIDE_MODAL](state) {
    state.isShowModal = false;
  },
  [types.TOGGLE_MODAL](state) {
    state.isShowModal = !state.isShowModal;
  },
  [types.SHOW_ICON](state) {
    state.isShowIcon = true;
  },
  [types.HIDE_ICON](state) {
    state.isShowIcon = false;
  },
  [types.MOMENT_OPEN](state) {
    state.momentOpen = new Date().getTime();
  },
  [types.MOMENT_CLOSE](state) {
    state.momentClose = new Date().getTime();
  }
};

export default mutations;
